/**
 * API Service for menu activity stats (page views & report downloads)
 */

import api from "../../auth/apiClient";
import { ACTIVITY_LOGS_API_CONFIG } from "./apiConfig";
import {
    ActivityRange,
    DailyActivityStat,
    DownloadStat,
    MenuStat,
    UserActivityStat,
    UserMenuStat,
} from "./types";

const { ENDPOINTS, TOP_LIMIT, ACTIVE_USERS_LIMIT } = ACTIVITY_LOGS_API_CONFIG;

const activityLogsApiService = {
    async getTopMenus(range: ActivityRange): Promise<MenuStat[]> {
        const { data } = await api.get<MenuStat[]>(ENDPOINTS.TOP_MENUS, { params: { ...range, limit: TOP_LIMIT } });
        return data;
    },

    async getTopUsers(range: ActivityRange): Promise<UserActivityStat[]> {
        const { data } = await api.get<UserActivityStat[]>(ENDPOINTS.TOP_USERS, {
            params: { ...range, limit: ACTIVE_USERS_LIMIT },
        });
        return data;
    },

    async getUserMenus(range: ActivityRange, email: string): Promise<UserMenuStat[]> {
        const { data } = await api.get<UserMenuStat[]>(ENDPOINTS.USER_MENUS, { params: { ...range, email } });
        return data;
    },

    async getTopDownloads(range: ActivityRange): Promise<DownloadStat[]> {
        const { data } = await api.get<DownloadStat[]>(ENDPOINTS.TOP_DOWNLOADS, {
            params: { ...range, limit: TOP_LIMIT },
        });
        return data;
    },

    async getDaily(range: ActivityRange): Promise<DailyActivityStat[]> {
        const { data } = await api.get<DailyActivityStat[]>(ENDPOINTS.DAILY, { params: range });
        return data;
    },
};

export default activityLogsApiService;
